import { UNLIMITED_VALUE } from '../constants';

export const RESPONSIBLE_GAMING_BET_LIMITS = 'responsiblegamingbetlimits';
export const RESPONSIBLE_GAMING_LOSS_LIMITS = 'responsiblegaminglosslimits';

export const PERIODS = ['session', 'day', 'week', 'month'];

export const PERIOD_CODES = {
    1: 'session',
    2: 'day',
    3: 'week',
    4: 'month'
};

export const PREDEFINED_TYPES = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    FORCED: 'forced'
};

export const ADDITIONAL_OPTIONS = {
    empty: {
        value: '',
        displayValueTKey: 'placeholder.limit.empty'
    },
    unlimited: {
        value: UNLIMITED_VALUE,
        displayValueTKey: 'placeholder.limit.unlimited'
    }
};
